import { api, setSessionToken } from './api.js';
import {
  clearLocalAcceptanceSession,
  persistLocalAcceptanceSession,
} from './local-acceptance-session.js';

export type AuthData = {
  sessionToken: string;
  user: { id: string; state: string };
  nextRoute: string;
};

let pendingAuthentication: Promise<AuthData> | null = null;

export function authenticateTelegram(initData: string): Promise<AuthData> {
  pendingAuthentication ??= api<AuthData>('/auth/telegram', {
    method: 'POST',
    body: JSON.stringify({ initData }),
  })
    .then((result) => {
      setSessionToken(result.sessionToken);
      return result;
    })
    .finally(() => {
      pendingAuthentication = null;
    });
  return pendingAuthentication;
}

export function authenticateLocalAcceptance(user: 'new' | 'one' | 'two'): Promise<AuthData> {
  pendingAuthentication ??= api<AuthData>('/auth/local-acceptance', {
    method: 'POST',
    body: JSON.stringify({ user }),
  })
    .then((result) => {
      setSessionToken(result.sessionToken);
      persistLocalAcceptanceSession(result);
      return result;
    })
    .finally(() => {
      pendingAuthentication = null;
    });
  return pendingAuthentication;
}

export async function logoutTelegram(): Promise<void> {
  await api('/auth/logout', { method: 'POST', body: JSON.stringify({ allDevices: false }) });
  setSessionToken(null);
  clearLocalAcceptanceSession();
}
